import React, { useEffect, useState, useMemo } from "react";
import Pagination from "../../Config/Pagination";
import { API_BASE_CRM_URL } from "../../Config/Config";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import AddLeadNote from "./AddLeadNote";
import { Button, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import Swal from "sweetalert2";
import axios from "axios";

const { Search } = Input;

const LeadNotes = ({ id, type }) => {
  const customerId = id;
  const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
  const userId = userDetails?.staffid;

  const Type = "Lead";

  console.log(customerId, Type, "typeeeeeeee");
  const [loading, setLoading] = useState(false);

  const [notesList, setNotesList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [openNoteDrawer, setOpenNoteDrawer] = useState(false);

  console.log(notesList, "noteslist");

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 12;
  const filteredItems = useMemo(() => {
    setCurrentPage(1);

    return notesList.filter(
      (item) =>
        item?.added_by_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.description?.toLowerCase().includes(searchTerm.toLowerCase()),
    );
  }, [notesList, searchTerm]);
  console.log(filteredItems, "filtereddddddddd");
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const handleExcelDownload = () => {
    if (notesList.length === 0) {
      return;
    }

    const wb = XLSX.utils.book_new();

    // Convert your data to worksheet format
    const wsData = notesList.map((item) => ({
      Company: item.company,

      "Date Created": formatDate(item.datecreated),
      City: item.city,
      State: item.state,
      Zipcode: item.zip,
      Website: item.website,
    }));

    const ws = XLSX.utils.json_to_sheet(wsData);

    XLSX.utils.book_append_sheet(wb, ws, "notesList");

    // Save the workbook to a file
    XLSX.writeFile(wb, "notesList.xlsx");
  };

  const handlePDFDownload = () => {
    const doc = new jsPDF();

    // Set properties for PDF
    doc.setProperties({
      title: "Customers Notes Data",
    });

    // Add data to PDF
    const tableData = [];

    // Add a header row
    const headers = [
      "Company",
      "Phone Number",
      "email",
      "Created Date",
      "City",
      "Website",
    ];
    tableData.push(headers);

    // Add rows
    notesList.forEach((item) => {
      const row = [];
      row.push(
        item.company,
        item.phonenumber,
        item.email,
        formatDate(item.datecreated),
        item.city,
        item.website,
      );
      tableData.push(row);
    });

    // Generate table
    doc.autoTable({
      head: [headers],
      body: tableData.slice(1),
    });

    // Save the PDF
    doc.save("CustomersData.pdf");
  };

  const fetchNotesList = async (clientId, type) => {
    setLoading(true);
    try {
      const response = await fetch(
        `${API_BASE_CRM_URL}notes/GetNotes?rel_id=${clientId}&rel_type=${type}`,
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();

      if (data.Status) {
        setNotesList(data.ResultData);
      } else {
        console.error("Fetched data is not an array:", data);
        setNotesList([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotesList(customerId, Type);
  }, [customerId, Type]);

  const [showUpdateNote, setShowUpdateNote] = useState(false);

  const [updateNoteData, setUpdateNoteData] = useState({
    id: "",
    description: "",
  });

  const handleNoteChange = (e) => {
    setUpdateNoteData({
      ...updateNoteData,
      description: e.target.value,
    });
  };

  const handleUpdateNote = async () => {
    try {
      setLoading(true);

      const payload = {
        id: updateNoteData.id,
        description: updateNoteData.description,
      };

      const response = await axios.post(
        `${API_BASE_CRM_URL}notes/UpdateNote`,
        payload,
      );

      if (response.data.Status) {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: response.data.Message,
          showConfirmButton: false,
          timer: 2000,
        });

        setShowUpdateNote(false);

        fetchNotesList(); // refresh notes
      }
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Update Failed",
        text: error?.response?.data?.Message || "Failed to update note",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteNote = async (id) => {
    const result = await Swal.fire({
      title: "Delete Note?",
      text: "This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, Delete",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) return;

    try {
      setLoading(true);

      const response = await axios.post(`${API_BASE_CRM_URL}notes/DeleteNote`, {
        id,
      });

      if (response.data.Status) {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: response.data.Message,
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });

        fetchNotesList(); // refresh notes
      }
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Delete Failed",
        text: error?.response?.data?.Message || "Failed to delete note",
        confirmButtonColor: "#dc3545",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="">
        <div className="d-flex justify-content-between py-1 mb-1 gap-4">
          <div className="col-8">
            <Search
              placeholder="input search text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onSearch={(value) => setSearchTerm(value)}
              enterButton={
                <Button
                  type="primary"
                  icon={<SearchOutlined />}
                  style={{
                    backgroundColor: "#FF8D1F",
                    borderColor: "#FF8D1F",
                  }}
                />
              }
            />
          </div>
          <div className="col-4 mt-1">
            <ul className="d-inline-flex list-unstyled gap-1 mb-0 justify-content-end">
              <li>
                <a
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="PDF"
                  onClick={handlePDFDownload}
                  className="btn btn-light btn-sm px-0"
                >
                  <i
                    className="fa-solid fa-file-pdf fa-2xl"
                    style={{ color: "#ff0000" }}
                  ></i>
                </a>
              </li>

              <li>
                <a
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Excel"
                  onClick={handleExcelDownload}
                  className="btn btn-light btn-sm"
                >
                  <i
                    className="fa-solid fa-file-excel fa-2xl"
                    style={{ color: "#217346" }}
                  ></i>
                </a>
              </li>

              <li>
                <button
                  type="button"
                  className="btn btn-sm"
                  style={{ backgroundColor: "#1B2850" }}
                  onClick={() => setOpenNoteDrawer(true)}
                >
                  <i
                    className="fa-solid fa-plus"
                    style={{ color: "white" }}
                  ></i>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="row g-2 mb-4">
        {loading ? (
          <div className="col-12 text-center">
            <div className="containers m-auto">
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
            </div>
          </div>
        ) : currentItems && currentItems.length > 0 ? (
          currentItems.map((item, index) => (
            <div key={index} className="col-xl-4 col-lg-6 col-md-6">
              <div className="card mb-1 rounded-4">
                <div className="card-body">
                  <h6 className=" mb-2">
                    <div className="d-flex align-items-center justify-content-between gap-2">
                      <div>
                        <i
                          className="fa-solid fa-user me-2"
                          style={{ color: "#1B2850" }}
                        ></i>
                        <span className="fw-semibold">
                          {item?.added_by_name || "N/A"}
                        </span>
                      </div>
                      <div className="d-flex align-items-center justify-content-center">
                        <i
                          className="fa-solid fa-calendar-plus me-2"
                          style={{ color: "#1B2850" }}
                        ></i>
                        <span>
                          {formatDate(item.dateadded)}
                        </span>

                        <i
                          className="fa-solid fa-pen-to-square ms-2"
                          style={{ color: "#1B2850" }}
                          onClick={() => {
                            setUpdateNoteData({
                              id: item.id,
                              description: item.description,
                            });

                            setShowUpdateNote(true);
                          }}
                        ></i>
                        <i
                          className="fa-solid fa-trash  text-danger ms-2"
                          // style={{ color: "#1B2850" }}
                          onClick={() => handleDeleteNote(item.id)}
                        ></i>
                      </div>
                    </div>
                  </h6>

                  <div className="customer-details">
                    <div className="row g-2">
                      <div className="col-12">
                        <div className="d-flex align-items-start">
                          {(() => {
                            const description = item.description || "";

                            // Extract URL from Markdown: [text](url)
                            const markdownMatch = description.match(
                              /\[([^\]]+)\]\((https?:\/\/[^)]+)\)/,
                            );

                            // Get actual URL
                            const mapUrl = markdownMatch
                              ? markdownMatch[2]
                              : description.match(
                                  /https?:\/\/(?:www\.google\.com\/maps|maps\.app\.goo\.gl)[^\s,)]+/,
                                )?.[0];

                            const isMapUrl =
                              mapUrl &&
                              (mapUrl.startsWith(
                                "https://www.google.com/maps",
                              ) ||
                                mapUrl.startsWith("https://maps.app.goo.gl"));

                            if (isMapUrl) {
                              return (
                                <button
                                  type="button"
                                  className="btn btn-link p-0 text-decoration-none"
                                  onClick={() =>
                                    window.open(
                                      mapUrl,
                                      "_blank",
                                      "noopener,noreferrer",
                                    )
                                  }
                                >
                                     <i
                                    className="fa-regular fa-file-lines me-2 mt-1"
                                    style={{ color: "#1B2850" }}
                                  ></i>
                                  <i className="fa-solid fa-location-dot me-2"></i>
                                </button>
                              );
                            }

                            return (
                              <>
                                <i
                                  className="fa-regular fa-file-lines me-2 mt-1"
                                  style={{ color: "#1B2850" }}
                                ></i>

                                <span
                                  className=""
                                  style={{ maxWidth: "100%" }}
                                  title={description}
                                >
                                  {description || "N/A"}
                                </span>
                              </>
                            );
                          })()}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="col-12 text-center text-muted">No data available</div>
        )}
      </div>

      {showUpdateNote && (
        <>
          <div
            className="offcanvas offcanvas-bottom show"
            style={{
              visibility: "visible",
              height: "45vh",
              zIndex: 1055,
              borderTopLeftRadius: "20px",
              borderTopRightRadius: "20px",
              backgroundColor: "#fff",
            }}
          >
            {/* Drag Handle */}
            <div className="text-center pt-2">
              <div
                style={{
                  width: "50px",
                  height: "5px",
                  background: "#ccc",
                  borderRadius: "10px",
                  margin: "0 auto",
                }}
              />
            </div>

            {/* Header */}
            <div className="offcanvas-header border-bottom d-flex justify-content-between align-items-center">
              <h5
                className="mb-0"
                style={{
                  color: "#1B2850",
                  fontWeight: "600",
                }}
              >
                <i className="fa-solid fa-note-sticky me-2"></i>
                Update Note
              </h5>

              <div className="d-flex gap-2">
                {/* Cancel */}
                <div
                  onClick={() => setShowUpdateNote(false)}
                  style={{
                    width: "38px",
                    height: "38px",
                    background: "#fff",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                  }}
                >
                  <i
                    className="fa-solid fa-xmark"
                    style={{
                      color: "#dc3545",
                      fontSize: "16px",
                    }}
                  />
                </div>

                {/* Save */}
                <div
                  onClick={handleUpdateNote}
                  style={{
                    width: "38px",
                    height: "38px",
                    background: "#fff",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                  }}
                >
                  <i
                    className={`fa-solid ${
                      loading ? "fa-spinner fa-spin" : "fa-check"
                    }`}
                    style={{
                      color: "#198754",
                      fontSize: "16px",
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Body */}
            <div className="offcanvas-body">
              <label className="form-label fw-semibold">Description</label>

              <textarea
                rows={5}
                className="form-control"
                placeholder="Enter Note Description"
                value={updateNoteData.description}
                onChange={handleNoteChange}
              />
            </div>
          </div>

          <div
            className="offcanvas-backdrop fade show"
            onClick={() => setShowUpdateNote(false)}
          ></div>
        </>
      )}

      <Pagination
        itemsPerPage={itemsPerPage}
        totalItems={filteredItems.length}
        paginate={paginate}
        currentPage={currentPage}
      />
      <AddLeadNote
        open={openNoteDrawer}
        onClose={() => setOpenNoteDrawer(false)}
        customerId={customerId}
        addedFrom={userId}
        onSuccess={() => {
          // Call Notes API again here
          fetchNotesList(customerId, Type);
        }}
      />
    </>
  );
};

export default LeadNotes;
